import React from "react";
import { IonCard, IonItem, IonLabel, IonBadge, IonIcon, IonGrid, IonRow, IonCol } from "@ionic/react";
import { call, locationOutline, mailOutline, calendarOutline, personOutline } from "ionicons/icons";
import { makeCall } from "../hooks/common";

interface IProps {
  enquiry: any;
  agents?: { farmUserId: string; name: string }[];
  onClick: (enquiry: any) => void;
}

const statusColor = (status: string) => {
  switch (status) {
    case 'NEW': return 'tertiary';
    case 'OPEN': return 'warning';
    case 'PURCHASED': return 'success';
    case 'NOT_PURCHASED': return 'danger';
    default: return 'medium';
  }
};

const statusLabel = (status: string) => status ? status.replace('_', ' ') : 'Unknown';

const EnquiryCard: React.FC<IProps> = ({ enquiry, agents, onClick }) => {
  const assigneeName = agents?.find(a => a.farmUserId === enquiry.assigneeId)?.name || enquiry.assigneeId;

  return (
    <IonCard onClick={() => onClick(enquiry)} style={{ margin: '8px', borderRadius: '12px' }}>
      <IonItem style={{ '--background': 'transparent', '--border-color': 'transparent' }}>
        <IonLabel>
          <h2 style={{ fontWeight: 'bold', fontSize: '16px', margin: 0 }}>{enquiry.name || 'Unknown'}</h2>
          {enquiry.expectedItemType && (
            <p style={{ fontSize: '12px', color: '#999', margin: '2px 0 0 0' }}>
              {enquiry.expectedItemType}{enquiry.expectedQuantity ? ` × ${enquiry.expectedQuantity}` : ''}
            </p>
          )}
        </IonLabel>
        <IonBadge color={statusColor(enquiry.status)} slot="end">{statusLabel(enquiry.status)}</IonBadge>
      </IonItem>
      <IonGrid style={{ padding: '0 16px 16px 16px' }}>
        <IonRow>
          <IonCol size="12" sizeMd="6">
            {enquiry.mobile && (
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <IonIcon icon={call} style={{ fontSize: '16px', marginRight: '8px', color: '#666' }} />
                <span
                  style={{ fontSize: '14px', cursor: 'pointer', color: '#3880ff' }}
                  onClick={e => makeCall(e, enquiry.mobile)}
                >
                  {enquiry.mobile}
                </span>
              </div>
            )}
            {enquiry.email && (
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <IonIcon icon={mailOutline} style={{ fontSize: '16px', marginRight: '8px', color: '#666' }} />
                <span style={{ fontSize: '14px' }}>{enquiry.email}</span>
              </div>
            )}
            {enquiry.location && (
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <IonIcon icon={locationOutline} style={{ fontSize: '16px', marginRight: '8px', color: '#666' }} />
                <span style={{ fontSize: '14px', color: '#666' }}>{enquiry.location}</span>
              </div>
            )}
          </IonCol>
          <IonCol size="12" sizeMd="6">
            {enquiry.assigneeId && (
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <IonIcon icon={personOutline} style={{ fontSize: '16px', marginRight: '8px', color: '#666' }} />
                <span style={{ fontSize: '14px', color: '#666' }}>{assigneeName}</span>
              </div>
            )}
            {enquiry.message && (
              <div style={{ marginBottom: '8px' }}>
                <span style={{ fontSize: '13px', color: '#666' }}>{enquiry.message}</span>
              </div>
            )}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <IonIcon icon={calendarOutline} style={{ fontSize: '16px', marginRight: '8px', color: '#666' }} />
              <span style={{ fontSize: '12px', color: '#666' }}>
                {enquiry.created_date
                  ? new Intl.DateTimeFormat("en-GB", { month: "short", day: "2-digit", year: "numeric" }).format(new Date(enquiry.created_date))
                  : ''}
              </span>
            </div>
          </IonCol>
        </IonRow>
      </IonGrid>
    </IonCard>
  );
};

export default EnquiryCard;
